import React from "react";
import Layout from "./../components/Layout/Layout";
import PageUnderConstruction from "./../components/PageUnderConstruction";
import Timeline from "./../components/Timeline";
import events from "./../data/event";

const Events = () => {
    return (
        <Layout>
            <div>
                <h2>2024 Long Beach Prone Paddle Challenge - 8/4/2024 </h2>
            </div>
            <Timeline events={events} />
        </Layout>
    )
}

export default Events;